const version = "2.8.4";

export { version };
//# sourceMappingURL=version.mjs.map
